import styled from 'styled-components';

export const Wrapper = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 15px;
	padding: 10px 15px;
	background-color: #e8eff7;
	border-radius: 6px;
`;
